// Permite que código fuera del árbol React (ej. interceptores axios)
// use el navigate de React Router sin causar un full page reload.
let _navigate = null;

export const setNavigate = (fn) => { _navigate = fn; };

export const navigateSPA = (path, options) => {
  if (_navigate) {
    _navigate(path, options);
  } else {
    window.location.href = path;
  }
};
